import { useQuery } from '@tanstack/react-query';
import { PocApi } from '../../../apis';

export const useQueryPocUsers = ({ orgId }: { orgId: string }) => {
  const initialData = {
    isPocProvisioned: false,
    limit: 100,
    users: [],
  };
  return useQuery({
    initialData,
    queryKey: ['pocUsers', orgId],
    queryFn: async () => {
      try {
        return (await PocApi.getPocUsers(orgId)).data;
      } catch {
        console.error('Get pocUsers error');
        return initialData;
      }
    },
  });
};
